import { render, staticRenderFns } from "./NewContext.vue?vue&type=template&id=e95ae3c6&scoped=true"
import script from "./NewContext.vue?vue&type=script&lang=js"
export * from "./NewContext.vue?vue&type=script&lang=js"
import style0 from "./NewContext.vue?vue&type=style&index=0&id=e95ae3c6&prod&lang=css&scoped=true"
import style1 from "./NewContext.vue?vue&type=style&index=1&id=e95ae3c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95ae3c6",
  null
  
)

export default component.exports